import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { BetaFeature, BetaFeaturesState, PendingRemoval, UserSearchResult } from './types'

export const initialState: BetaFeaturesState = {
  isLoading: false,
  error: null,
  features: [],
  searchQueries: {},
  searchResults: {},
  searchingFeature: null,
  pendingRemoval: null,
}

const fetchRequestHandler = (state: BetaFeaturesState) => {
  state.isLoading = true
  state.error = null
}

const fetchSuccessHandler = (state: BetaFeaturesState, action: PayloadAction<BetaFeature[]>) => {
  state.isLoading = false
  state.features = action.payload
}

const fetchFailureHandler = (state: BetaFeaturesState, action: PayloadAction<string>) => {
  state.isLoading = false
  state.error = action.payload
}

const setSearchQueryHandler = (state: BetaFeaturesState, action: PayloadAction<{ feature: string; query: string }>) => {
  state.searchQueries[action.payload.feature] = action.payload.query
}

const searchRequestHandler = (state: BetaFeaturesState, action: PayloadAction<string>) => {
  state.searchingFeature = action.payload
}

const searchSuccessHandler = (
  state: BetaFeaturesState,
  action: PayloadAction<{ feature: string; users: UserSearchResult[] }>,
) => {
  state.searchingFeature = null
  state.searchResults[action.payload.feature] = action.payload.users
}

const searchFailureHandler = (state: BetaFeaturesState) => {
  state.searchingFeature = null
}

const clearSearchHandler = (state: BetaFeaturesState, action: PayloadAction<string>) => {
  delete state.searchQueries[action.payload]
  delete state.searchResults[action.payload]
}

const askRemovalHandler = (state: BetaFeaturesState, action: PayloadAction<PendingRemoval>) => {
  state.pendingRemoval = action.payload
}

const cancelRemovalHandler = (state: BetaFeaturesState) => {
  state.pendingRemoval = null
}

export const betaFeaturesSlice = createSlice({
  name: 'betaFeaturesTools',
  initialState,
  reducers: {
    fetchRequest: fetchRequestHandler,
    fetchSuccess: fetchSuccessHandler,
    fetchFailure: fetchFailureHandler,
    setSearchQuery: setSearchQueryHandler,
    searchRequest: searchRequestHandler,
    searchSuccess: searchSuccessHandler,
    searchFailure: searchFailureHandler,
    clearSearch: clearSearchHandler,
    askRemoval: askRemovalHandler,
    cancelRemoval: cancelRemovalHandler,
  },
})

export const {
  fetchRequest,
  fetchSuccess,
  fetchFailure,
  setSearchQuery,
  searchRequest,
  searchSuccess,
  searchFailure,
  clearSearch,
  askRemoval,
  cancelRemoval,
} = betaFeaturesSlice.actions

export default betaFeaturesSlice.reducer
